module.exports = __webpack_public_path__ + "img/0-83.42b0ce31.jpg";